import { Dropdown, Menu, PageHeader, Upload } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
// import { useAppDispatch } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { success } from 'components/RevxMessage';
import { isPlatformOrg } from 'domains/orgDomain';
import { MultiTypeEnum } from 'domains/skuDomain';
import { useOrgId } from 'hooks/useOrg';
import { useTranslation } from 'react-i18next';

export const SkuHeader = () => {
  const { t } = useTranslation();
  const orgId = useOrgId();
  const isBaseOrg = isPlatformOrg({ id: orgId });
  const dispatch = useAppDispatch();
  const curItem = useAppSelector((state) => state.sku.curItem);
  const createWithInheritanceVisible = useAppSelector(
    (state) => state.sku.createWithInheritanceVisible
  );
  const skuTesterVisible = useAppSelector(
    (state) => state.sku.skuTesterState.visible
  );
  const importLoading = useAppSelector(
    (state) => state.loading.effects.excelDefinition.importSku
  );
  const exportLoading = useAppSelector(
    (state) => state.loading.effects.excelDefinition.exportSku
  );
  const defaultPagerCurrentPage = useAppSelector(
    (state) => state.sku.defaultPager.currentPage
  );

  const disabled =
    !!curItem || createWithInheritanceVisible || skuTesterVisible;

  const createButton = (
    <Dropdown
      disabled={disabled}
      key="dropdown"
      overlay={
        <Menu>
          <Menu.Item
            key="sku-from-scratch"
            onClick={async () => {
              await dispatch.sku.saveSku({
                multiType: MultiTypeEnum.BOTH,
              });
              dispatch.sku.refresh();
              success(t('platform.sku.createSuccess'));
            }}
          >
            <span>{t('platform.sku.singleSkuFromScratch')}</span>
          </Menu.Item>
          <Menu.Item
            key="multi-from-scratch"
            onClick={async () => {
              await dispatch.sku.saveSku({
                multiType: MultiTypeEnum.WRAPPER,
              });
              dispatch.sku.refresh();
              success(t('platform.sku.createSuccess'));
            }}
          >
            <span>{t('platform.sku.multiSkuFromScratch')}</span>
          </Menu.Item>
          {!isBaseOrg && (
            <Menu.Item
              key="sku-with-inheritance"
              onClick={() => {
                dispatch.sku.setState({
                  createWithInheritanceVisible: true,
                });
              }}
            >
              <span>{t('platform.sku.skuWithInheritance')}</span>
            </Menu.Item>
          )}
        </Menu>
      }
    >
      <RevxButton key="create" disabled={disabled} brandGreen>
        {t('platform.sku.create')}
      </RevxButton>
    </Dropdown>
  );

  const importFile = (
    <Upload
      maxCount={1}
      disabled={importLoading}
      showUploadList={false}
      customRequest={async (option) => {
        const formData = new FormData();
        formData.append('file', option.file);
        await dispatch.excelDefinition.importSku(formData);
        if (+defaultPagerCurrentPage === 1) {
          dispatch.sku.refresh();
        } else {
          dispatch.sku.setState({
            defaultPager: {
              pageSize: 20,
              currentPage: 1,
            },
            inheritBasePager: {
              pageSize: 20,
              currentPage: 1,
            },
            inheritParentPager: {
              pageSize: 20,
              currentPage: 1,
            },
            inheritCurrentPager: {
              pageSize: 20,
              currentPage: 1,
            },
          });
        }
      }}
    >
      <RevxButton key="import" brandGreen loading={importLoading}>
        {t('common.import')}
      </RevxButton>
    </Upload>
  );

  const exportFile = (
    <RevxButton
      key="create"
      brandGreen
      loading={exportLoading}
      onClick={() => {
        dispatch.excelDefinition.exportSku();
      }}
    >
      {t('common.export')}
    </RevxButton>
  );

  return (
    <PageHeader
      ghost={false}
      title={
        isBaseOrg ? t('platform.header.baseSkus') : t('platform.header.skus')
      }
      className="platform-page-header"
      extra={[exportFile, importFile, createButton]}
    />
  );
};
